import * as H from 'history';

import { FieldChangeData } from 'etc/types';

export enum Step {
  STEP1_DESCRIPTION = 1,
  STEP2_EXTERNAL_REPORTED_CONTENT = 2,
  STEP2_EMPLOYEE_REPORTED_CONTENT = 3,
  STEP3_SUCCESS = 4,
}

export type OnFieldChangeFunction = (fieldChangeData: FieldChangeData) => void;

export interface StepProps {
  forceValidation: boolean;
  loading: boolean;
  setLoading: (_: boolean) => void;
  location: H.Location;
  onStepSubmit: () => void;
  onFieldChange: OnFieldChangeFunction;
}

export interface Experiments {
  name: string;
  group: string;
}
